import { useCallback, useState } from "react";

import { useGetCallLogs } from "../../../hooks/useGetCallLogs";
import { useUpsertNotes } from "../../../hooks/useUpsertNotes";
import useCallNotesModal from "./useCallNotesModal";
import useSnackbarState from "./useSnackbarState";

const useCallManagementActions = ({ uamId, adminId }) => {
  const [isCallLogsModalOpen, setIsCallLogsModalOpen] = useState(false);
  const [viewNotesText, setViewNotesText] = useState("");
  const [viewUrlText, setViewUrlText] = useState("");
  const {
    notesModal,
    closeNotesModal,
    setNotesText,
  } = useCallNotesModal();
  const {
    errorSnackbar,
    successSnackbar,
    showError,
    showSuccess,
    closeError,
    closeSuccess,
  } = useSnackbarState();

  const { data: callLogs, isLoading: isLoadingLogs } = useGetCallLogs(
    uamId,
    adminId,
    isCallLogsModalOpen,
  );

  const {
    mutate: upsertNotes,
    isPending: isUpsertingNotesPending,
    isLoading: isUpsertingNotesLoading,
  } = useUpsertNotes();
  const isUpsertingNotes = isUpsertingNotesPending || isUpsertingNotesLoading;

  const handleUpsertNotes = useCallback(() => {
    upsertNotes(
      { call_id: notesModal.callId, notes: notesModal.text },
      {
        onSuccess: () => {
          showSuccess("Notes saved successfully.");
          closeNotesModal();
        },
        onError: (err) => {
          showError(err.message || "Failed to save notes.");
        },
      },
    );
  }, [
    closeNotesModal,
    notesModal.callId,
    notesModal.text,
    showError,
    showSuccess,
    upsertNotes,
  ]);

  return {
    isCallLogsModalOpen,
    setIsCallLogsModalOpen,
    viewNotesText,
    setViewNotesText,
    viewUrlText,
    setViewUrlText,
    notesModal,
    closeNotesModal,
    setNotesText,
    errorSnackbar,
    successSnackbar,
    closeError,
    closeSuccess,
    callLogs,
    isLoadingLogs,
    isUpsertingNotes,
    handleUpsertNotes,
  };
};

export default useCallManagementActions;
